import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
} from 'reactstrap';
import _ from 'lodash';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import styles from './styles.module.css';
import HttpErrorHandler from '../../components/http-error-handler';
import withAPI from '../../hocs/with-api';
import OrderDetails from '../../components/order-details';
import SearchOrderForm from '../../components/search-order-form';
import Map from '../../components/map';
import PrimaryButtonWithIcon from '../../components/primary-button-with-icon';

class SearchOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails: null,
      initialPosition: undefined,
    };
  }

  async componentDidMount() {
    this.waitForRecaptchaBadge();
  }

  waitForRecaptchaBadge = (attempts = 0) => {
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) {
      badge.style.visibility = 'visible';
    } else if (attempts < 10) {
      setTimeout(() => this.waitForRecaptchaBadge(attempts + 1), 300); // try again in 300ms
    } else {
      console.warn('reCAPTCHA badge not found after multiple attempts');
    }
  };

  componentWillUnmount() {
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) {
      badge.style.visibility = 'hidden';
    }
  }

  onLoginClick = () => {
    const { history } = this.props;
    history.push('/login');
  }

  onSubmit = async (values) => {
    const { httpRequest, httpPostLoading } = this.props;

    if (httpPostLoading) {
      return;
    }

    const { orderNumber, token } = values;

    this.setState({ initialPosition: undefined });
    const data = {
      order_number: orderNumber,
      recaptcha_token: token,
    };

    const response = await httpRequest({
      method: 'post',
      url: 'search/order',
      data,
    }).catch(() => {});

    if (response) {
      const order = response.data;
      this.setState({
        orderDetails: order,
      });

      if (_.get(order, 'vehicle')) {
        const { geo } = _.get(order, 'vehicle');
        if (geo && _.get(geo, 'started', false)) {
          this.setState({
            initialPosition: [geo.lat, geo.long],
            channel: `order.${order.id}.vehicle.geo.changed`,
          });
        }
      }
    }
  }


  render() {
    const {
      t,
      httpPostLoading,
      httpPostFailReason,
      httpPostFailed,
    } = this.props;
    const {
      orderDetails,
      channel,
      initialPosition,
    } = this.state;

    return (
      <div className={`flex-start position-ref full-height page-container ${styles.grid}`}>
        <Row className={styles.alignCenter}>
          <div className={styles.container}>
            <Row className={`${styles.fullWidth}`}>
              <Col className={styles.logoContainer} lg="50">
                <div className={styles.logo}>
                  <img src="/assets/lfg-logo-u.png" alt="Logo" />
                </div>
                <div className={styles.logoText}>
                  { t('lf.logoBlock.name') }
                </div>
              </Col>
              <Col className={styles.buttonContainer}>
                <PrimaryButtonWithIcon
                  onClick={this.onLoginClick}
                  title={t('login')}
                  width="200px"
                  height="44px"
                  icon="/assets/images/lock-icon@2x.png"
                />
              </Col>
            </Row>

            <div className={`${styles.formContainer} ${styles.row}`}>
              <Row>
                <Col className={styles.formCol}>
                  <p className="lf-main-text">{ t('orders.searchOne') }</p>
                </Col>
              </Row>

              {
              httpPostFailed && httpPostFailReason
              && (
                <div className="content-lg">
                  <Col className={styles.formCol}>
                    <HttpErrorHandler {...httpPostFailReason} />
                  </Col>
                </div>
              )
              }
              <Row>
                <Col className={styles.formCol}>
                  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY_V3}>
                    <SearchOrderForm
                      t={t}
                      onSubmit={this.onSubmit}
                      isLoading={httpPostLoading}
                    />
                  </GoogleReCaptchaProvider>
                </Col>
              </Row>
              { !orderDetails && (
              <Row>
                <Col style={{ margin: '0px', padding: '0px' }}>
                  <p className="copyright-text">
                     Copyright ©
                    {(new Date().getFullYear())}
                  </p>
                </Col>
              </Row>
              )}
            </div>
          </div>
        </Row>

        <Row>
          <div className={styles.lgContainer}>
            <Col className={styles.formCol}>
              {
                orderDetails
                && (
                <OrderDetails
                  shouldShowLessInfo={_.get(orderDetails, 'status.name', '') === 'Delivered'}
                  style={{ padding: '0px' }}
                  {...orderDetails}
                />
                )
              }
            </Col>
          </div>
        </Row>

        { orderDetails && channel && initialPosition && (
          <>
            <Row className={styles.row}>
              <Col>
                <p className="lf-main-text">{ t('map.view') }</p>
              </Col>
            </Row>
            <Row>
              <Col className="mt-10">
                <Map channel={channel} initialPosition={initialPosition} />
              </Col>
            </Row>
          </>
        )}
        {

        orderDetails && (
        <Row>
          <Col md="12">
            <p className="copyright-text">
            Copyright ©
              {(new Date().getFullYear())}
            </p>
          </Col>
        </Row>
        )
}
      </div>
    );
  }
}

SearchOrders.propTypes = {
  t: PropTypes.func.isRequired,
  httpRequest: PropTypes.func.isRequired,
  httpPostLoading: PropTypes.bool,
  httpPostFailed: PropTypes.bool,
  httpPostFailReason: PropTypes.any,
  history: PropTypes.object.isRequired,
};

SearchOrders.defaultProps = {
  httpPostLoading: false,
  httpPostFailReason: undefined,
  httpPostFailed: false,
};

export default compose(
  withTranslation(),
  withRouter,
  withAPI,
)(SearchOrders);
